

import Image from "next/image";

const Hero = ({ title, subtitle, image }) => (
  <div className="relative h-[50vh] md:h-[60vh] lg:h-[70vh] w-full overflow-hidden">
    {/* ✅ Updated Next.js Image Component */}
    <Image 
      src={image} 
      alt={title || "Hero Image"} // ✅ Provide a fallback alt text
      fill // ✅ Replaces deprecated layout="fill"
      priority
      className="object-cover" // ✅ Replaces deprecated objectFit="cover"
    />
    
    {/* ✅ Hero Text Overlay */}
    <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-center items-center text-white text-center px-6">
      <h1 className="text-4xl md:text-6xl font-bold">{title}</h1>
      
      {/* ✅ Render subtitle ONLY if it exists */}
      {subtitle && <p className="text-lg mt-4 max-w-2xl">{subtitle}</p>}
    </div>
  </div>
);

export default Hero;